// @ts-nocheck: converted from JS

import Settings from '@/components/Studies/Settings';

export default Settings;
